export const setCallerInsights = (data) => ({
    type: 'SET_CALLERINSIGHTS',
    payload: data,
  });

